module.exports = __webpack_public_path__ + "static/media/google.b7711d4e.png";